import axiosInstance from '../utils/axiosInstance';

export interface RafOrgSettings {
  notifyNewMatter: boolean;
  intelligentModeDefault: boolean;
  notificationEmail: string;
}

interface SettingsResponse {
  success: boolean;
  data: RafOrgSettings;
}

export async function getMatterSettings(): Promise<RafOrgSettings> {
  const res = await axiosInstance.get<SettingsResponse>('/matters/settings');
  return res.data.data;
}

export async function updateMatterSettings(
  patch: Partial<RafOrgSettings>,
): Promise<RafOrgSettings> {
  const res = await axiosInstance.post<SettingsResponse>('/matters/settings', patch);
  return res.data.data;
}
